module.exports = __webpack_public_path__ + "static/media/HCMM710.470995e8.jpg";